import React, { Component } from "react";
import Avatar from "@mui/material/Avatar";
// import moment from "moment";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Menu, MenuItem } from "@mui/material";
import { Button, Form, Modal } from "react-bootstrap";
import EquipmentApi from "../../api/EquipmentApi";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EnlargeImage from "../../customFunctions/EnlargeImage";
import getBaseUrl from "../../customFunctions/getBaseUrl";
import AuthService from "../../session/AuthService";
import { API_URL } from "../../config/app-config";

class EquipmentGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opendeleteproductDialogue: false,
      equipmentImage: "",
      equipmentName : ""
    };
  }

 

  render() {
    console.log("this.props.equipmentList", this.props.equipmentList);
    // const baseUrl = getBaseUrl();
    return (
      <>
        <div className="adjust-grid-container">
          <div className="Center-the-Grid">
            <table id="myTable">
              <thead>
                <tr style={{ borderBottom: "1px solid #BCBFBE" }}>
                  <th>Equipment Name</th>
                  <th>Model</th>
                  <th>Year Acquired</th>
                  {/* <th>Date</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.props.equipmentList.map((e) => (
                  <tr>
                    <td class="avatar-cell">
                      <div class="avatar">
                        <Avatar
                          onClick={() =>this.handleAvatarClick(e)}
                          alt={`${e.equipmentName}`}
                          src={
                            e.equipmentImage !== null
                              ? `${API_URL}auth/assets/${
                                  e.equipmentImage
                                }`
                              : null
                          }
                          sx={{
                            objectFit: "cover",
                            transition: "transform 0.3s ease-in-out", // Add a smooth transition effect
                            "&:hover": {
                              transform: "scale(1.8)",
                              zIndex: 2, // Example: Enlarge the image size on hover
                            },
                          }}
                          loading="lazy"
                        >
                          {e.equipmentImage === null && (
                            <span>
                              {e.equipmentName.charAt(0).toUpperCase()}
                            </span>
                          )}
                        </Avatar>
                        <div class="name">
                          {e.equipmentName.charAt(0).toUpperCase() +
                            e.equipmentName.slice(1)}
                        </div>
                      </div>
                    </td>
                    <td>{e.equipmentModel}</td>
                    <td>{e.year_acquired}</td>
                    {/* <td>{moment(e.createdDate).format("dddd, D MMMM YYYY")}</td> */}
                    <td>
                      {
                        <>
                          <MoreHorizIcon
                            onClick={(event) =>
                              this.handleFilterClick(event, e)
                            }
                          />{" "}
                          <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleFilterClose2}
                            className="exclude-menu"
                          >
                            <MenuItem
                              onClick={(e) => this.handleFilterClose("edit", e)}
                            >
                              <EditOutlinedIcon />{" "}
                              <span className="inisde-the-action">Edit</span>
                            </MenuItem>
                            {String(AuthService.getUserTypeAdmin()) !== "3" && (
                              <>
                              <MenuItem
                              onClick={() => this.handleFilterClose("delete")}
                            >
                              <DeleteOutlinedIcon />{" "}
                              <span className="inisde-the-action">Delete</span>
                            </MenuItem>
                            <MenuItem
                              onClick={(e) =>
                                this.handleFilterClose("add-serviceRecord", e)
                              }
                            >
                              <AddCircleOutlineIcon />{" "}
                              <span className="inisde-the-action">
                                Add ServiceRecord
                              </span>
                            </MenuItem>
                              </>
                            )}
                            

                            {this.state.showViewServiceRecord && (
                              <MenuItem
                                onClick={(e) =>
                                  this.handleFilterClose(
                                    "view-serviceRecord",
                                    e
                                  )
                                }
                              >
                                <VisibilityIcon />{" "}
                                <span className="inisde-the-action">
                                  View ServiceRecord
                                </span>
                              </MenuItem>
                            )}
                          </Menu>
                        </>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
              {this.props.equipmentList.length === 0 && (
                <>
                  {" "}
                  <div
                    style={{
                      fontSize: "larger",
                      fontWeight: "bolder",
                    }}
                  >
                    {"No Data Found"}
                  </div>{" "}
                </>
              )}
            </table>
          </div>
          {this.state.isModalOpen && (
          <EnlargeImage 
            onClose={this.handleModalClose} 
            imageUrl={this.state.equipmentImage !== null ? `${API_URL}auth/assets/${this.state.equipmentImage}` : null}
            />
          
        )}
        </div>
        {this.state.opendeleteproductDialogue && this.deleteproductPopUp()}
       
      </>
    );
  }


  handleAvatarClick = (e) => {
    console.log("e in check", e);

    if (e.equipmentImage !== null) {
      this.setState({
        isModalOpen: true,
        equipmentImage: e.equipmentImage,
        equipmentName: e.equipmentName,
      });
    }
  
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  handleFilterClick = (event, data) => {
    console.log("event", event, data);
    this.props.getequipmentName(data);
    this.setState(
      {
        anchorEl: event.target,
        selectedEditData: data,
        showViewServiceRecord: data.allow,
      },
      () => {
        console.log("selectedEditData", this.state.selectedEditData);
      }
    );
  };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleFilterClose = (getState) => {
    if (getState === "edit") {
      this.props.ActiveEdit(this.state.selectedEditData);
      this.handleFilterClose2();
    } else if (getState === "delete") {
      this.setState({
        opendeleteproductDialogue: true,
        anchorEl: null,
      });
    } else if (getState === "add-serviceRecord") {
      this.props.openCreateServiceRecord(this.state.selectedEditData);
    } else if (getState === "view-serviceRecord") {
      this.props.openListServiceRecord(this.state.selectedEditData);
    }

    this.setState({
      anchorEl: null,
    });
  };

  handleClose = () => {
    this.setState({ opendeleteproductDialogue: false });
  };

  deleteBuilding = () => {
    let obj = {
      equipmentId: this.state.selectedEditData.equipmentId,
    };

    EquipmentApi.deleteEquipment(obj).then((response) => {
      if (response.data) {
        this.handleClose();
        this.props.deleteandeditload();
      }
    });
  };

  deleteproductPopUp = () => {
    console.log("state id deleteproductPopUp", this.state.product_id);
    return (
      <Modal show={true} size="md" centered onHide={this.handleClose}>
        <Modal.Header closeButton className="CNSHeader">
          <h3 className="titleMd uppercase">Delete Equipment</h3>
        </Modal.Header>
        <Form>
          <Modal.Body className="">
            <div className="basicInfoWrapper newServiceFormWrapper">
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Are you sure to delete this Equipment</Form.Label>
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer className="CNSFooter">
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
            <Button
              variant="success"
              type="button"
              onClick={this.deleteBuilding}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };
}
export default EquipmentGrid;
